import React from "react";
import { Form } from "antd";
import { useTranslate } from "@refinedev/core";
import { PlaybookAddOnCard } from "../PlaybookAddOnCard";
import { useAddonDraft } from "../../context/PlaybookDraftContext";
import { CHAT_ADDON_ID } from "../../data/addons";
import { ChatbotFormValues } from "./types";
import { CHATBOT_DEFAULTS } from "./defaults";
import { ChatbotSettingsFields } from "./chatbot/ChatbotSettingsFields";

const KEY = "createExperience.addOns.aiChat";

// TODO: replace with a real credit estimate once the backend exposes one for
// this add-on. Hardcoded for now (matches the catalog placeholder).
const ESTIMATED_CREDITS = 200;

/**
 * Settings card for the "AI Chat" (backend `Chatbot`) add-on (Step 2 customize
 * view). Every field maps onto `ChatbotFunctionalSettings`, so the draft goes
 * straight to `PATCH /projects/{id}/add-ons/settings` untranslated. The
 * generation branch (`suggested_questions`) is backend-authored and not shown.
 */
export const ChatbotConfigCard: React.FC = () => {
  const t = useTranslate();
  const [form] = Form.useForm<ChatbotFormValues>();
  const { initialValues, onValuesChange } = useAddonDraft(
    CHAT_ADDON_ID,
    CHATBOT_DEFAULTS
  );

  return (
    <PlaybookAddOnCard
      itemId={CHAT_ADDON_ID}
      title={t(`${KEY}.title`)}
      credits={ESTIMATED_CREDITS}
      description={t(`${KEY}.description`)}
    >
      <Form<ChatbotFormValues>
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onValuesChange={onValuesChange}
      >
        <ChatbotSettingsFields variant="create" />
      </Form>
    </PlaybookAddOnCard>
  );
};

export default ChatbotConfigCard;
